// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading{width:100%;display:flex;text-align:center;min-height:400px}.loading img{margin:auto}`, "",{"version":3,"sources":["webpack://./app/javascript/components/common/Loading/Loading.scss"],"names":[],"mappings":"AAAA,SACE,UAAA,CACA,YAAA,CACA,iBAAA,CACA,gBAAA,CACA,aACE,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
